/* Kraskaart-popup. Config + texts come from snippets/hdx-scratch-popup.liquid (window.HDX_SCRATCH). */
(function () {
  var C = window.HDX_SCRATCH;
  if (!C || C.started) return;
  C.started = true;
  var T = C.t[C.lang] || C.t[String(C.lang || '').split('-')[0]] || C.t.en;
  var KEY = 'hdxScr', START = 'hdxScrStart', PV = 'hdxScrPv';
  var force = /[?&]hdx_scratch=1/.test(location.search);

  function store(s, k, v) {
    try {
      var o = s === 'l' ? localStorage : sessionStorage;
      if (v === undefined) return o.getItem(k);
      o.setItem(k, v);
    } catch (e) { return null; }
  }
  function remember(state) { store('l', KEY, JSON.stringify(state)); }
  function fill(s) { return s.replace('{v}', C.value); }
  function track(step) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'hdx_scratch', hdx_scratch_step: step }); } catch (e) {}
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('hdx_scratch_' + step, { lang: C.lang, country: C.country }); } catch (e) {}
  }

  if (!force) {
    var st = null;
    try { st = JSON.parse(store('l', KEY) || 'null'); } catch (e) {}
    if (st && (st.s === 'sub' || (st.until && Date.now() < st.until))) return;
    /* Came in from a Klaviyo mail: already on the list */
    if (/[?&](_kx=|utm_source=klaviyo)/i.test(location.search)) { remember({ s: 'sub' }); return; }
  }

  var pv = (+store('s', PV) || 0) + 1;
  store('s', PV, pv);
  var start = +store('s', START);
  if (!start) { start = Date.now(); store('s', START, start); }

  /* Shopify cookie banner still open: wait until it is answered, never stack on top of it */
  function bannerOpen() {
    var b = document.getElementById('shopify-pc__banner');
    return !!(b && b.offsetHeight && getComputedStyle(b).visibility !== 'hidden');
  }

  var shown = false;
  function trigger() {
    if (shown) return;
    var wait = C.minWait - (Date.now() - start);
    if (!force && wait > 0) { setTimeout(trigger, wait + 50); return; }
    if (bannerOpen()) { setTimeout(trigger, 1000); return; }
    shown = true;
    if (force) return open();
    /* Known Klaviyo profile (bought or signed up before): stay away, like the old popup did */
    var done = false;
    function go(identified) { if (done) return; done = true; if (identified) remember({ s: 'sub' }); else open(); }
    setTimeout(function () { go(false); }, 1500);
    try {
      var k = window.klaviyo;
      if (k && typeof k.isIdentified === 'function') Promise.resolve(k.isIdentified()).then(go, function () { go(false); });
      else go(false);
    } catch (e) { go(false); }
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  var root, ticket, canvas, step2, step3, sub, hint, revealBtn, revealed = false, submitted = false;

  function open() {
    root = el('div', 'hdx-scr');
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'hdxScrTitle');
    root.setAttribute('data-hdx-no-us', '');
    var card = el('div', 'hdx-scr__card');
    root.appendChild(card);

    var x = el('button', 'hdx-scr__x');
    x.type = 'button';
    x.setAttribute('aria-label', T.close);
    x.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3 3l10 10M13 3L3 13"/></svg>';
    x.addEventListener('click', close);
    card.appendChild(x);

    var logo = el('img', 'hdx-scr__logo');
    logo.src = C.logo; logo.alt = 'Human Dynamix';
    card.appendChild(logo);

    card.appendChild(el('p', 'hdx-scr__eyebrow', T.eyebrow));
    var h = el('h2', 'hdx-scr__title', T.title); h.id = 'hdxScrTitle';
    card.appendChild(h);
    sub = el('p', 'hdx-scr__sub', T.sub);
    card.appendChild(sub);

    ticket = el('div', 'hdx-scr__ticket');
    ticket.appendChild(el('span', 'hdx-scr__pill', '🎁 ' + T.free));
    ticket.appendChild(el('span', 'hdx-scr__gift', T.gift));
    ticket.appendChild(el('span', 'hdx-scr__worth', fill(T.worth)));
    canvas = el('canvas', 'hdx-scr__canvas');
    canvas.tabIndex = 0;
    canvas.setAttribute('role', 'button');
    canvas.setAttribute('aria-label', T.reveal);
    ticket.appendChild(canvas);
    card.appendChild(ticket);

    hint = el('p', 'hdx-scr__hint', T.hint);
    card.appendChild(hint);
    revealBtn = el('button', 'hdx-scr__reveal', T.reveal);
    revealBtn.type = 'button';
    revealBtn.addEventListener('click', reveal);
    card.appendChild(revealBtn);

    /* Step 2: e-mail */
    step2 = el('div');
    step2.hidden = true;
    step2.appendChild(el('p', 'hdx-scr__won', fill(T.won)));
    step2.appendChild(el('p', 'hdx-scr__won-sub', T.won_sub));
    var form = el('form', 'hdx-scr__form');
    form.noValidate = true;
    var input = el('input', 'hdx-scr__input');
    input.type = 'email'; input.name = 'email'; input.autocomplete = 'email'; input.required = true;
    input.placeholder = T.email; input.setAttribute('aria-label', T.email);
    var err = el('p', 'hdx-scr__err');
    err.setAttribute('role', 'alert');
    var btn = el('button', 'hdx-scr__btn', T.cta);
    btn.type = 'submit';
    form.appendChild(input); form.appendChild(err); form.appendChild(btn);
    form.addEventListener('submit', function (e) { e.preventDefault(); send(input, err, btn); });
    step2.appendChild(form);
    var fine = el('p', 'hdx-scr__fine', T.consent + ' ');
    var a = el('a', null, T.privacy);
    a.href = C.privacy; a.target = '_blank'; a.rel = 'noopener';
    fine.appendChild(a);
    step2.appendChild(fine);
    var no = el('button', 'hdx-scr__no', T.no);
    no.type = 'button';
    no.addEventListener('click', close);
    step2.appendChild(no);
    card.appendChild(step2);

    /* Step 3: done */
    step3 = el('div');
    step3.hidden = true;
    step3.appendChild(el('p', 'hdx-scr__won', T.done_title));
    step3.appendChild(el('p', 'hdx-scr__won-sub', T.done_sub));
    var shop = el('button', 'hdx-scr__btn hdx-scr__btn--dark', T.shop);
    shop.type = 'button';
    shop.addEventListener('click', close);
    step3.appendChild(shop);
    card.appendChild(step3);

    root.addEventListener('click', function (e) { if (e.target === root) close(); });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(root);
    requestAnimationFrame(function () {
      paint();
      root.classList.add('is-open');
    });
    track('view');
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    if ((e.key === 'Enter' || e.key === ' ') && document.activeElement === canvas) { e.preventDefault(); reveal(); }
  }

  function close() {
    if (!root) return;
    if (!submitted) remember({ s: 'snooze', until: Date.now() + C.snoozeDays * 864e5 });
    track(submitted ? 'closed_after_submit' : revealed ? 'closed_after_reveal' : 'closed');
    document.removeEventListener('keydown', onKey);
    root.classList.remove('is-open');
    var r = root;
    root = null;
    setTimeout(function () { r.remove(); }, 300);
  }

  /* Gold foil + scratching */
  var ctx, ratio = 1, drawing = false, last = null, moves = 0;
  function paint() {
    var r = canvas.getBoundingClientRect();
    ratio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(r.width * ratio);
    canvas.height = Math.round(r.height * ratio);
    ctx = canvas.getContext('2d');
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    var w = r.width, h = r.height;
    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#B8862B'); g.addColorStop(.32, '#E6C066'); g.addColorStop(.5, '#FBEBB0');
    g.addColorStop(.66, '#D8A845'); g.addColorStop(1, '#A87720');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, w, h);
    for (var i = 0; i < 1600; i++) {
      ctx.fillStyle = Math.random() < .5 ? 'rgba(255,255,255,.10)' : 'rgba(90,60,10,.10)';
      ctx.fillRect(Math.random() * w, Math.random() * h, 1.4, 1.4);
    }
    ctx.strokeStyle = 'rgba(255,255,255,.12)';
    ctx.lineWidth = 1;
    for (var d = -h; d < w; d += 9) { ctx.beginPath(); ctx.moveTo(d, h); ctx.lineTo(d + h, 0); ctx.stroke(); }
    ctx.font = '700 ' + Math.round(Math.min(26, w / 11)) + 'px ' + getComputedStyle(root).fontFamily;
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.shadowColor = 'rgba(110,70,0,.45)'; ctx.shadowBlur = 6; ctx.shadowOffsetY = 1;
    ctx.fillStyle = 'rgba(255,255,255,.92)';
    ctx.fillText(T.foil, w / 2, h / 2);
    ctx.shadowColor = 'transparent';
    ctx.globalCompositeOperation = 'destination-out';
    ctx.strokeStyle = ctx.fillStyle = '#000';
    ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.lineWidth = Math.max(34, w / 9);

    canvas.addEventListener('pointerdown', down);
    canvas.addEventListener('pointermove', move);
    canvas.addEventListener('pointerup', up);
    canvas.addEventListener('pointercancel', up);
  }
  function pos(e) { var r = canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
  function down(e) {
    if (revealed) return;
    drawing = true; last = pos(e);
    try { canvas.setPointerCapture(e.pointerId); } catch (x) {}
    ctx.beginPath(); ctx.arc(last.x, last.y, ctx.lineWidth / 2, 0, Math.PI * 2); ctx.fill();
    if (!moves) track('scratch');
  }
  function move(e) {
    if (!drawing || revealed) return;
    var p = pos(e);
    ctx.beginPath(); ctx.moveTo(last.x, last.y); ctx.lineTo(p.x, p.y); ctx.stroke();
    last = p;
    if (++moves % 6 === 0 && cleared() > .45) reveal();
  }
  function up() { drawing = false; if (!revealed && cleared() > .45) reveal(); }
  function cleared() {
    try {
      var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data, n = 0, t = 0;
      for (var i = 3; i < data.length; i += 4 * 24) { t++; if (data[i] < 128) n++; }
      return t ? n / t : 0;
    } catch (e) { return 0; }
  }

  function reveal() {
    if (revealed) return;
    revealed = true;
    ticket.classList.add('is-revealed');
    sub.hidden = true; hint.hidden = true; revealBtn.hidden = true;
    step2.hidden = false;
    track('reveal');
    if (window.matchMedia && matchMedia('(pointer:fine)').matches) {
      setTimeout(function () { var i = step2.querySelector('input'); i && i.focus(); }, 450);
    }
  }

  function send(input, err, btn) {
    var email = input.value.trim();
    err.textContent = '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = T.err_email; input.focus(); return; }
    btn.disabled = true;
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: C.klaviyo.source,
          profile: { data: { type: 'profile', attributes: {
            email: email,
            location: { country: C.country },
            properties: { hdx_lang: C.lang, hdx_signup_country: C.country, hdx_signup: 'kraskaart' }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: C.klaviyo.list } } }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(C.klaviyo.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      submitted = true;
      remember({ s: 'sub' });
      try { window.klaviyo && klaviyo.identify && klaviyo.identify({ email: email }); } catch (e) {}
      step2.hidden = true;
      step3.hidden = false;
      track('submit');
    }).catch(function () {
      err.textContent = T.err_send;
      btn.disabled = false;
    });
  }

  C.open = function () { if (!root) { shown = true; open(); } };

  if (force) { setTimeout(trigger, 600); return; }
  if (pv >= 3) trigger();
  setTimeout(trigger, C.delay);
  window.addEventListener('scroll', function onScroll() {
    var d = document.documentElement;
    if ((window.scrollY + window.innerHeight) / Math.max(d.scrollHeight, 1) >= .4) { window.removeEventListener('scroll', onScroll); trigger(); }
  }, { passive: true });
  document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) trigger(); });
})();
